import { React, i18n, inject, pr, ui } from "aaa";
import { MessageScreen } from "../common/MessageScreen";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { ReissueCardStore } from "./ReissueCardStore";
import { isCreditCard } from "types/card";
import * as moment from "moment";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: ReissueCardStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore", "authStore")
export class ReissueCardSuccess extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        const card = this.props.store.cardStore.card;
        const creditCard = card ? isCreditCard(card) : false;
        const product = card ? card.productI18N : "-";
        const cardNumber = card ? card.number : "-";
        const message = card && card.cardDeliveryMode === "HOME" ?
            "reissueCard.success.home" :
            "reissueCard.success.branch";

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                messageComponent={
                    <div>
                        <i18n.FormattedHTMLMessage id={message} values={{ product, number: cardNumber }} />
                        {creditCard && <span><br /><br />{ui.__("reissueCard.warning.creditCard")}</span>}
                    </div>}
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("geoControl")}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardSuccess.tsx